/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Login_To_LoginInputs */

const en_action_login_to_login = /** @type {(inputs: Action_Login_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to login`)
};

const de_action_login_to_login = /** @type {(inputs: Action_Login_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Login-Seite`)
};

/**
* | output |
* | --- |
* | "Go to login" |
*
* @param {Action_Login_To_LoginInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const action_login_to_login = /** @type {((inputs?: Action_Login_To_LoginInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Login_To_LoginInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_action_login_to_login(inputs)
	return en_action_login_to_login(inputs)
});